// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_8-2";
export var blackBorderOnHover = "_8-7";
export var cell = "_8-6";
export var cellContainer = "_8-3";
export var checked = "_8-8";
export var disabled = "_8-5";
export var featuredIconCellContainer = "_8-9";
export var featuredIconTextContainer = "_8-b";
export var featuredIconWrapper = "_8-a";
export var noBorder = "_8-c";
export var orangeSelectedRow = "_s-3";
export var overflowableText = "_8-0";
export var overflowableTextContainer = "_8-1";
export var row = "_9-0";
export var rowCheckboxCell = "_8-4";
export var selectableTable = "_s-2";